import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { listModuleLenses } from 'root/src/client/logic/list/lenses'

const { viewListSubtitle } = listModuleLenses

export default (state, { moduleId }) => viewListSubtitle(moduleId, moduleDescriptions)
